"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Subject_1 = require("rxjs/Subject");
const settings_base_1 = require("./settings-base");
const settings_type_1 = require("./settings-type");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const measure_model_factory_1 = require("../model/measure-model-factory");
class MainSettings extends settings_base_1.SettingsBase {
    /**
     * Initializes the state and organizes communication with other related settings components.
     * If the service is not provided for communication then no actions are performed at all.
     * @param {T} self the identifier of the component
     * @param {CommunicationService} communicationService the optional service for inter-component communication
     */
    constructor(communicationService) {
        super(settings_type_1.SettingsType.MAIN, communicationService);
        this.hasChanges = false;
        this.isDataTableShowed = false;
        this.reportTitleChangeSubject = new Subject_1.Subject();
        this.isDataTableShowedChangeSubject = new Subject_1.Subject();
        /**
         * Report title
         * It is common for all report control types.
         */
        this._reportTitle = null;
        /**
         * The property describes is the control initialize by chart state
         */
        this._isInitializeWithState = false;
        this.reportTitleSubscription = null;
        this.measureModelFactory = new measure_model_factory_1.MeasureModelFactory();
        this.destroy$ = new Subject_1.Subject();
    }
    get reportTitle() {
        return this._reportTitle;
    }
    set reportTitle(value) {
        this._reportTitle = value;
        this.reportTitleChangeSubject.next();
    }
    get isInitializeWithState() {
        return this._isInitializeWithState;
    }
    set isInitializeWithState(value) {
        this._isInitializeWithState = value;
    }
    onDataTableShowedChange(value) {
        this.isDataTableShowed = value;
        this.isDataTableShowedChangeSubject.next();
    }
    clearReportTitleSubscription() {
        if (this.reportTitleSubscription) {
            this.reportTitleSubscription.unsubscribe();
        }
        this.reportTitleSubscription = null;
    }
    resetReportTitleSubscription() {
        this.clearReportTitleSubscription();
        this.reportTitleSubscription = this.reportTitleChangeSubject
            .debounceTime(500)
            .subscribe(() => {
            this.hasChanges = true;
            this.stateToOutputs();
        });
    }
    clearIsDataTableShowedSubscription() {
        if (this.isDataTableShowedSubscription) {
            this.isDataTableShowedSubscription.unsubscribe();
        }
        this.isDataTableShowedSubscription = null;
    }
    resetIsDataTableShowedSubscription() {
        this.clearIsDataTableShowedSubscription();
        this.isDataTableShowedSubscription = this.isDataTableShowedChangeSubject
            .debounceTime(500)
            .subscribe(() => {
            this.hasChanges = true;
            this.stateToOutputs();
        });
    }
    sendPreviewMessageToParent() {
        this.sendToParent(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW);
    }
}
exports.MainSettings = MainSettings;
//# sourceMappingURL=main-settings.js.map